/* tslint:disable */
/* eslint-disable */
/**
 * lq.api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Assessment,
    AssessmentFromJSON,
    AssessmentToJSON,
    BadRequestResult,
    BadRequestResultFromJSON,
    BadRequestResultToJSON,
    EmailAndAccessCodeRequest,
    EmailAndAccessCodeRequestFromJSON,
    EmailAndAccessCodeRequestToJSON,
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ResultsStatusResponse,
    ResultsStatusResponseFromJSON,
    ResultsStatusResponseToJSON,
} from '../models';


export interface CalculateResultsRequest {
    id: string;
}

export interface CreateAssessmentRequest {
    assessment?: Assessment;
}

export interface GetAssessmentByIdRequest {
    id: string;
}

export interface GetResultsRequest {
    id: string;
}

export interface GetResultsStatusRequest {
    id: string;
}

export interface StoreHipaaConsentPDFRequest {
    id: string;
}

export interface UpdateAssessmentByIdRequest {
    id: string;
    assessment?: Assessment;
}

/**
 * 
 */
export class AssessmentApi extends runtime.BaseAPI {


    /**
     */
    async calculateResultsRaw(requestParameters: CalculateResultsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling calculateResults.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Assessment/{id}/results/calculate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async calculateResults(requestParameters: CalculateResultsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.calculateResultsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createAssessmentRaw(requestParameters: CreateAssessmentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/Assessment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssessmentToJSON(requestParameters.assessment),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createAssessment(requestParameters: CreateAssessmentRequest, initOverrides?: RequestInit): Promise<void> {
        await this.createAssessmentRaw(requestParameters, initOverrides);
    }



    /**
     */
    async getAssessmentByIdRaw(requestParameters: GetAssessmentByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Assessment>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getAssessmentById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Assessment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssessmentFromJSON(jsonValue));
    }

    /**
     */
    async getAssessmentById(requestParameters: GetAssessmentByIdRequest, initOverrides?: RequestInit): Promise<Assessment> {
        const response = await this.getAssessmentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssessmentByUserRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Assessment>> {
        const queryParameters: any = {
            cb: Date.now()
        };

        const headerParameters: runtime.HTTPHeaders = {};
        const response = await this.request({
            path: `/api/Assessment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssessmentFromJSON(jsonValue));
    }

    /**
     */
    async getAssessmentByUser(initOverrides?: RequestInit): Promise<Assessment> {
        const response = await this.getAssessmentByUserRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getResultsRaw(requestParameters: GetResultsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getResults.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Assessment/{id}/results`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getResults(requestParameters: GetResultsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.getResultsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getResultsStatusRaw(requestParameters: GetResultsStatusRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ResultsStatusResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getResultsStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Assessment/{id}/results/status?cb={cb}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace('{cb}',(new Date()).getTime().toString()),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultsStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async getResultsStatus(requestParameters: GetResultsStatusRequest, initOverrides?: RequestInit): Promise<ResultsStatusResponse> {
        const response = await this.getResultsStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async storeHipaaConsentPDFRaw(requestParameters: StoreHipaaConsentPDFRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling storeHipaaConsentPDF.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Assessment/{id}/hipaaConsentPDF`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeHipaaConsentPDF(requestParameters: StoreHipaaConsentPDFRequest, initOverrides?: RequestInit): Promise<void> {
        await this.storeHipaaConsentPDFRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateAssessmentByIdRaw(requestParameters: UpdateAssessmentByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Assessment>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateAssessmentById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/Assessment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssessmentToJSON(requestParameters.assessment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssessmentFromJSON(jsonValue));
    }

    /**
     */
    async updateAssessmentById(requestParameters: UpdateAssessmentByIdRequest, initOverrides?: RequestInit): Promise<Assessment> {
        const response = await this.updateAssessmentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
